<template>
    <el-card class="box-card mt15">
        <template slot='header'>
        <div>备注详情</div>
        </template>
        <p v-if="status > 1" class="f12">{{data}}</p>
        <el-input
            type="textarea"
            :rows="6"
            style="font-size:12px;"
            v-model="textarea"
            placeholder="请输入需要备注信息，如：“内转”、“转款”、等标记信息对本流水进行备注记录！"
            v-else>
        </el-input>
    </el-card>
</template>
<script>
    export default {
        data () {
            return {
                textarea: ''
            }
        },
        props: {
            status: [String, Number], // 单据的状态
            data: {
                type: String,
                default: ''
            }
        },
        methods: {
            /**
             * 数据验证
             */
            validate () {
                if (this.textarea.length > 0) {
                    return true
                } else {
                    this.$message({
                        message: '请输入备注信息！',
                        type: 'warning'
                    })
                    return false
                }
            },
            /**
             * 获得数据
             */
            getData () {
                return {
                    remark: this.textarea
                }
            }
        }
    }
</script>